import React from 'react';

export interface RoundedButtonProps {
    id?: string;
    onClick?: () => void;
    label?: string;
    children?: React.ReactNode;
    selected?: boolean;
}

export const RoundedButton = (props: RoundedButtonProps) => {
    return (
        <button
            data-pw={(props as any)['data-pw'] ?? props.id}
            className={'rounded-button' + (props.selected ? ' selected' : '')}
            id={props.id}
            onClick={props.onClick}
        >
            {props.label ?? props.children}
        </button>
    );
};
